import { trits, trytes } from '@iota/converter'
import Kerl from '@iota/kerl'
import { key, signatureFragment, normalizedBundle, subseed } from '@iota/signing'

export function numToString(str: string) {
  let value = parseInt(str, 10)
  let valueTrits = trits(value)
  while (valueTrits.length < 243) {
    valueTrits[valueTrits.length] = 0
  }
  return trytes(valueTrits)
}

export function generateBundle(message: string) {
  let messageTrits = trits(message)
  let kerl = new Kerl()
  kerl.reset()
  kerl.absorb(messageTrits, 0, messageTrits.length)
  let messageHash: Int8Array = new Int8Array(243) //
  kerl.squeeze(messageHash, 0, 243)
  let bundle = trytes(messageHash)
  return bundle
}

export function generateSign(bundleHash: string, index: number, security: number, seed: string) {
  let normalized = normalizedBundle(trits(bundleHash))
  let keyVar = key(subseed(trits(seed), index), security)
  let trytesTotal = ''
  for (let i = 0; i < security; i++) {
    let bundleFragment = normalized.slice(27 * i, 27 * (i + 1))
    let fragment = keyVar.slice(6561 * i, 6561 * (i + 1))
    let signatureFragmentVar = signatureFragment(bundleFragment, fragment)
    let trytesVar = trytes(signatureFragmentVar)
    trytesTotal += trytesVar
  }
  return trytesTotal
}
